import { useMemo } from "react";
import { contactHeadlines } from "../utils/contactHeadlines";

function getHeadline(now) {
  const hour = now.getHours();
  const day = now.getDay();
  const month = now.getMonth();
  const date = now.getDate();

  // PRIORITY 1: Special Events
  for (const [key, event] of Object.entries(contactHeadlines.events)) {
    if (event.match(month, date)) {
      return event.headline;
    }
  }

  // PRIORITY 2: Extreme Times
  for (const [key, time] of Object.entries(contactHeadlines.extremeTimes)) {
    if (time.match(hour, day)) {
      return time.headline;
    }
  }

  // PRIORITY 3: Time + Day Combos
  for (const [key, combo] of Object.entries(contactHeadlines.timeDayCombos)) {
    if (combo.match(hour, day)) {
      return combo.headline;
    }
  }

  // FALLBACK
  return contactHeadlines.default;
}

export default function useContactHeadline() {
  const headline = useMemo(() => getHeadline(new Date()), []);
  return { headline, loading: false };
}